import { Loader2Icon, PhoneIcon } from 'lucide-react'
import type { ProvisioningStatus } from './whatsapp-settings.vm'

const TOTAL_PROVISIONING_STEPS = 6

const PROVISIONING_STEPS: Record<string, { label: string; step: number }> = {
	purchasing_number: { label: 'Purchasing a dedicated phone number...', step: 1 },
	registering_on_meta: { label: 'Registering your number with WhatsApp...', step: 2 },
	awaiting_verification: { label: 'Waiting for phone number verification...', step: 3 },
	submitting_verification: { label: 'Verifying your phone number...', step: 4 },
	creating_templates: { label: 'Creating message templates...', step: 5 },
	syncing_templates: { label: 'Syncing templates from WhatsApp...', step: 5 },
	completed: { label: 'Setup complete!', step: TOTAL_PROVISIONING_STEPS },
}

export function ProvisioningProgressCard({
	provisioningStatus,
}: {
	provisioningStatus: ProvisioningStatus
}) {
	const currentStep = provisioningStatus
		? PROVISIONING_STEPS[provisioningStatus]
		: PROVISIONING_STEPS.purchasing_number

	if (!currentStep) { return null }

	return (
		<div className="bg-blue-50 border border-blue-200 rounded-xl p-5">
			<div className="flex items-start gap-4">
				<div className="size-12 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0">
					<PhoneIcon className="size-6 text-blue-600" />
				</div>
				<div className="flex-1">
					<h3 className="font-medium text-gray-900 mb-1">Setting up your phone number</h3>
					<p className="text-sm text-gray-600 mb-3">
						We're provisioning a dedicated phone number for your WhatsApp Business Account. This usually
						takes a minute or two.
					</p>

					{/* Progress bar */}
					<div className="mb-2">
						<div className="flex justify-between text-xs text-gray-500 mb-1">
							<span>{currentStep.label}</span>
							<span>Step {currentStep.step} of {TOTAL_PROVISIONING_STEPS}</span>
						</div>
						<div className="w-full bg-blue-100 rounded-full h-2">
							<div
								className="bg-blue-500 h-2 rounded-full transition-all duration-500"
								style={{ width: `${(currentStep.step / TOTAL_PROVISIONING_STEPS) * 100}%` }}
							/>
						</div>
					</div>

					<div className="flex items-center gap-2 text-xs text-blue-600">
						<Loader2Icon className="size-3 animate-spin" />
						<span>This page will update automatically</span>
					</div>
				</div>
			</div>
		</div>
	)
}
